import Card from 'components/Badge';
import styled from 'styled-components';
import { Text } from 'v3/components';
import theme from 'v3/theme';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export const MapsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 10px;
  padding-top: 1rem;
`;

export const StyledClusterMarker = styled.div`
  color: #fff;
  background: #1978c8;
  border-radius: 50%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CardStyled = styled(Card)`
  && {
    position: absolute;
    left: 8px;
    right: 8px;
    bottom: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1) !important;
    background: white;
    opacity: 91%;
    z-index: 700;
    border-radius: 10px !important;
    width: auto;
    max-height: 150px;
    padding-right: 2.5rem;
    overflow: scroll;
    scroll-behavior: smooth;
    ::-webkit-scrollbar {
      width: 0.5rem;
      height: 0.5rem;
    }
    ::-webkit-scrollbar-track {
      background: ${(props) => props.theme.colors.light_gray};
      opacity: 0.5;
    }
    ::-webkit-scrollbar-thumb {
      background: ${(props) => props.theme.colors.gray};
      border-radius: 10px;
    }
    @media (max-width: 425px) {
      font-size: 1px !important;
    }

    @media (max-width: 1440px) {
      font-size: 1px;
    }
  }
`;

export const TextView = styled(Text)`
  padding-left: 2%;
  cursor: pointer;
  color: ${theme.colors.light_blue};
`;

export const OpenInNewIconStyled = styled(OpenInNewIcon)`
  width: 15px !important;
`;

export const CloseButtonStyled = styled.button`
  align-items: center;
  background: #ffffff;
  border: 1px solid ${(props) => props.theme.colors.light_gray};
  border-radius: 50%;
  color: ${(props) => props.theme.colors.gray};
  cursor: pointer;
  display: flex;
  font-size: 1rem;
  font-weight: 700;
  height: 1.5rem;
  justify-content: center;
  line-height: 1;
  padding: 0;
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  width: 1.5rem;
  z-index: 2;

  &:hover,
  &:focus {
    border-color: ${(props) => props.theme.colors.danger};
    color: ${(props) => props.theme.colors.danger};
    outline: none;
  }
`;

export const FullscreenButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1001;
  width: 36px;
  height: 36px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  color: #5f6368;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:hover,
  &:focus {
    background: #f8f9fa;
    outline: none;
  }
`;
